// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"_2H3hKBby8Afd-GrzW4Hws7"};